/*
 * Tabela de conversão de moeda — servida pelo CDN da Shopify.
 *
 * Antes este arquivo era carregado de https://shopify.jsdeliver.cloud/js/config.js,
 * um domínio de terceiros sem relação com a Shopify nem com o jsDelivr oficial
 * (cdn.jsdelivr.net). Qualquer pessoa com controle daquele domínio poderia trocar
 * o conteúdo deste script em todas as páginas da loja. O conteúdo foi copiado para
 * cá sem alterações de comportamento.
 *
 * ATENÇÃO: estas taxas são estáticas e estão desatualizadas. Para preços em moeda
 * real, use o Shopify Markets (conversão nativa no checkout), não esta tabela.
 */
var Currency = {
  rates: {
    USD: 1, EUR: 1.09598, GBP: 1.26944, CAD: 0.744461, ARS: 0.00348447, AUD: 0.649994,
    BRL: 0.203829, CLP: 0.00116445, CNY: 0.1384, CYP: 0.397899, CZK: 0.0455119,
    DKK: 0.146966, EEK: 0.0706676, HKD: 0.127901, HUF: 0.00285802, ISK: 0.00757108,
    INR: 0.0120583, JMD: 0.00647193, JPY: 0.00690184, LVL: 1.57329, LTL: 0.320236,
    MTL: 0.293496, MXN: 0.0588076, NZD: 0.598462, NOK: 0.0959285, PLN: 0.246862,
    SGD: 0.739383, SKK: 21.5517, SIT: 175.439, ZAR: 0.0527802, KRW: 7.51596e-7,
    SEK: 0.0926477, CHF: 1.1405, TWD: 0.0313379, UYU: 0.0264532, MYR: 0.218062,
    BSD: 1, CRC: 0.00186612, RON: 0.221667, PHP: 0.0176832, AED: 0.272294,
    VEB: 3.17843e-13, IDR: 6.52958e-5, TRY: 0.0370448, THB: 0.0285284, TTD: 0.147497,
    ILS: 0.268073, SYP: 7.63359e-5, XCD: 0.370064, COP: 2.52369e-4, RUB: 0.0100499,
    HRK: 0.145462, KZT: 0.00223927, TZS: 3.99796e-4, XPT: 913.52, SAR: 0.266667,
    NIO: 0.0273369, LAK: 5.15547e-5, OMR: 2.5974, AMD: 0.00259125, CDF: 4.039e-4,
    KPW: 0.00111111, SPL: 6, KES: 0.0069634, ZWD: 0.00276319, KHM: 0.00241969,
    MVR: 0.0651469, GTQ: 0.12722, BZD: 0.49634, BYR: 3.96574e-5, LYD: 0.208537,
    DZD: 0.00735339, BIF: 3.53027e-4, GIP: 1.26944, BOB: 0.144791, XOF: 0.00167081,
    STD: 4.48259e-5, NGN: 0.00130005, PGK: 0.285799, ERN: 0.0666667, MWK: 9.56043e-4,
    CUP: 0.0417265, GMD: 0.0165634, CVE: 0.00993906, BTN: 0.0120583, XAF: 0.00167081,
    UGX: 2.68023e-4, MAD: 0.101308, MNT: 2.87982e-4, LSL: 0.0527802, XAG: 22.6933,
    TOP: 0.426445, SHP: 1.26944, RSD: 0.00934342, HTG: 0.0073173, MGA: 2.24639e-4,
    MZN: 0.0156922, FKP: 1.26944, BWP: 0.0740092, HNL: 0.040659, PYG: 1.37614e-4,
    JEP: 1.26944, EGP: 0.0324002, LBP: 6.68022e-5, ANG: 0.559465, WST: 0.36339,
    TVD: 0.649994, GYD: 0.00478886, GGP: 1.26944, NPR: 0.0075329, KMF: 0.00222775,
    IRR: 2.36654e-5, XPD: 1298.17, SRD: 0.026139, TMM: 5.72483e-5, SZL: 0.0527802,
    MOP: 0.124176, BMD: 1, XPF: 0.00918432, ETB: 0.0181339, JOD: 1.41044,
    MDL: 0.0568215, MRO: 0.00264057, YER: 0.00399497, BAM: 0.560366, AWG: 0.558659,
    PEN: 0.27029, VEF: 3.17795e-10, SLL: 4.64931e-5, KYD: 1.2195, AOA: 0.0012106,
    TND: 0.324105, TJS: 0.0912373, SCR: 0.074414, LKR: 0.00311823, DJF: 0.00561643,
    GNF: 1.16493e-4, VUV: 0.00835147, SDG: 0.00166314, IMP: 1.26944, GEL: 0.380559,
    FJD: 0.445518, DOP: 0.0176522, XDR: 1.33611, MUR: 0.0221329, MMK: 4.7648e-4,
    LRD: 0.00535759, BBD: 0.5, ZMK: 5.216e-5, XAU: 1913.73, VND: 4.20057e-5,
    UAH: 0.0270969, TMT: 0.286241, IQD: 7.63953e-4, BGN: 0.560366, KGS: 0.0113609,
    RWF: 8.47735e-4, BHD: 2.65957, UZS: 8.30636e-5, PKR: 0.00347232, MKD: 0.0178405,
    AFN: 0.0118874, NAD: 0.0527802, BDT: 0.00913657, AZN: 0.588328, SOS: 0.00175737,
    QAR: 0.274725, PAB: 1, CUC: 1, SVC: 0.114286, SBD: 0.119201, ALL: 0.0105226,
    BND: 0.739383, KWD: 3.24986, GHS: 0.0896184, ZMW: 0.05216, XBT: 29120,
    NTD: 0.0337206, BYN: 0.396574, CNH: 0.137841, MRU: 0.0264057, STN: 0.0448258,
    VES: 0.0317795, MXV: 0.458027, VED: 0.0317795
  },
  convert: function (amount, from, to) {
    return (amount * this.rates[from]) / this.rates[to];
  }
};
